import WidgetModule from "@eisinc/Overrides/Widgets/OrderConfirmation/OrderConfirmationBillingInformation";

export * from "@eisinc/Overrides/Widgets/OrderConfirmation/OrderConfirmationBillingInformation";

export default WidgetModule;
